/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface ImpersonatedByState {
  hasImpersonatedBy: boolean;
}

const initialState: ImpersonatedByState = {
  hasImpersonatedBy: false,
};

export const impersonationBySlice = createSlice({
  name: 'impersonatedBy',
  initialState,
  reducers: {
    setHasImpersonatedBy: (state, { payload }) => {
      state.hasImpersonatedBy = payload;
    },
  },
  extraReducers: () => {},
});

export const { setHasImpersonatedBy } = impersonationBySlice.actions;
export const impersonatedBySelector = (state: RootState) =>
  state.impersonatedBy;
